module.exports = __webpack_public_path__ + "img/card_sv3.b838806.png";